function filterCustomDropdown() {
  const filterInputs = document.querySelectorAll(
    '.filter__custom-dropdown__filter-list input[type="checkbox"]',
  );
  const filterClearBtn = document.querySelector(
    '.filter__custom-dropdown_button--clear',
  );
  const filterCloseBtn = document.querySelector(
    '.filter__custom-dropdown__close-button',
  );
  const filterDropdown = document.querySelector(
    '.filter__custom-dropdown-wrapper',
  );
  const filterDropdownInner = document.querySelector(
    '.filter__custom-dropdown-innerWrapper',
  );
  const filterBtn = document.querySelector('.facets__heading-filter');
  const productTypeFilterBtn = document.querySelector(
    '.facets__heading-filter__product-type',
  );
  const categoryFilterBtn = document.querySelector(
    '.facets__heading-filter__category',
  );
  const categoryFilterDropdown = document.querySelector(
    '.filter__custom-dropdown-wrapper__category',
  );
  const categoryFilterCloseBtn = document.querySelector(
    '.filter__custom-dropdown__category-close-button',
  );
  const filterOverlay = document.querySelector(
    '.filter__custom-dropdown__overlay',
  );
  const categoryFilterOverlay = document.querySelector(
    '.filter__custom-dropdown-wrapper__category_overlay',
  );

  // filter clear button function
  function clearFilters(btn, filters) {
    if (btn && filters) {
      btn.addEventListener('click', (e) => {
        filters.forEach((input) => {
          input.checked = false;
        });
        $('.facets__selected').addClass('hidden');
      });
    }
  }
  clearFilters(filterClearBtn, filterInputs);

  function toggleFilterDropdown(btn, dropdown) {
    if (btn && dropdown) {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (dropdown.classList.contains('active')) {
          dropdown.classList.remove('active');
        } else {
          dropdown.classList.add('active');
        }
      });
    }
  }
  toggleFilterDropdown(filterBtn, filterDropdown);
  toggleFilterDropdown(filterCloseBtn, filterDropdown);
  // toggleFilterDropdown(productTypeFilterBtn, filterDropdown);
  toggleFilterDropdown(categoryFilterBtn, categoryFilterDropdown);
  toggleFilterDropdown(categoryFilterCloseBtn, categoryFilterDropdown);
  toggleFilterDropdown(filterOverlay, filterDropdown);
  toggleFilterDropdown(categoryFilterOverlay, categoryFilterDropdown);

  function closeDropdownWhenClickedOutside(dropdown, btn) {
    if (dropdown && btn) {
      window.addEventListener('click', (e) => {
        if (
          e.target.closest('.filter__custom-dropdown-wrapper') == null &&
          e.target != btn
        ) {
          if (dropdown.classList.contains('active')) {
            dropdown.classList.remove('active');
          }
        }
      });
    }
  }
  // closeDropdownWhenClickedOutside(filterDropdown, filterBtn);

  /* function filterMobileIosHotFix(dropdownInner, dropdown) {
        if (dropdownInner && dropdown) {
            if (window.innerWidth <= 425) {
                const ua = window.navigator.userAgent;
                const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
                const webkit = !!ua.match(/WebKit/i);
                const iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
    
                if (iOSSafari) {
                    // dropdownInner.style.minHeight = 'calc(150vh)';
                }
    
                const announcementBar = document.querySelector('#shopify-section-announcement-bar');
                const header = document.querySelector('.header-wrapper');
                const mobileMenu = document.querySelector('.mrMobiMenu-simpleNav-container');
    
                dropdown.style.height = `calc(100vh - ${announcementBar.clientHeight}px - ${header.clientHeight}px - ${mobileMenu.clientHeight}px)`;
            }
        }
    }
    filterMobileIosHotFix(filterDropdownInner, filterDropdown); */
}

export { filterCustomDropdown as default };
